import { z } from "zod";

import { MAX_VALUE_CENTS } from "@/lib/currency.ts";

export const stageSchema = z.object({
	name: z.string().trim().min(1, "Informe o nome da etapa"),
	description: z.string().optional(),
	parentId: z.string().optional(),
	kind: z.enum(["stage", "substage", "service"]),
	valueCents: z
		.number()
		.int()
		.min(0)
		.max(MAX_VALUE_CENTS, "Informe um valor de até R$ 99.999.999.999,99")
		.nullable(),
	status: z
		.enum(["pending", "in_progress", "completed", "cancelled"])
		.optional(),
});

export type StageFormValues = z.infer<typeof stageSchema>;
